import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function useScrollMemory(containerRef: React.RefObject<HTMLElement | null>) {
  const { pathname } = useLocation();
  const scrollPositions = useRef<Map<string, number>>(new Map());

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const savedPosition = scrollPositions.current.get(pathname) || 0;
    container.scrollTop = savedPosition;

    const handleScroll = () => {
      scrollPositions.current.set(pathname, container.scrollTop);
    };

    container.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [containerRef, pathname]);

  const clearScrollMemory = () => {
    scrollPositions.current.clear();
  };

  return { clearScrollMemory };
}
